// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codigoBarra {
  width: 100%;
  height: 100%;
  position: relative;
}

.overlay {
  background-color: rgba(125, 125, 125, 0.8);
  position: absolute;
}

.cuadrado {
  position: absolute;
  border: solid rgb(255, 157, 0) 3px;
  text-align: center;
}

.instrucciones {
  position: absolute;
  color: rgb(153, 153, 153);
  top: 10%;
  width: 100%;
}

.botones {
  color: white;
  position: absolute;
  font-size: 45px;
}
.botones.boton-volver {
  bottom: 10%;
  left: 10%;
}
.botones.boton-volver .volver-texto {
  font-size: 16px;
  font-family: roboto;
  margin-top: 5px;
}
.botones.boton-camara {
  bottom: 10%;
  left: 46%;
}
.botones.boton-flash {
  bottom: 10%;
  right: 10%;
}
.botones:active {
  font-size: 47px;
}

.cargando {
  position: absolute;
  bottom: 50%;
  left: 46%;
  font-size: 45px;
  color: rgb(143, 143, 143);
}
.cargando.hidden {
  display: none;
}

:host zxing-scanner {
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/modulos/codigo-barras/components/lector-codigo-barras/lector-codigo-barras.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AACD;;AACA;EACC,0CAAA;EACA,kBAAA;AAED;;AAAA;EACC,kBAAA;EACA,kCAAA;EACA,kBAAA;AAGD;;AADA;EACC,kBAAA;EACA,yBAAA;EACA,QAAA;EACA,WAAA;AAID;;AAFA;EACC,YAAA;EACA,kBAAA;EACA,eAAA;AAKD;AAHC;EACC,WAAA;EACA,SAAA;AAKF;AAJE;EACC,eAAA;EACA,mBAAA;EACA,eAAA;AAMH;AAFC;EACC,WAAA;EACA,SAAA;AAIF;AAFC;EACC,WAAA;EACA,UAAA;AAIF;AAFC;EACC,eAAA;AAIF;;AADA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;AAID;AAHC;EACC,aAAA;AAKF;;AADA;EACC,YAAA;EACA,WAAA;AAID","sourcesContent":[".codigoBarra {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tposition: relative;\r\n}\r\n.overlay {\r\n\tbackground-color: rgba(125, 125, 125, 0.8);\r\n\tposition: absolute;\r\n}\r\n.cuadrado {\r\n\tposition: absolute;\r\n\tborder: solid rgb(255, 157, 0) 3px;\r\n\ttext-align: center;\r\n}\r\n.instrucciones {\r\n\tposition: absolute;\r\n\tcolor: rgb(153, 153, 153);\r\n\ttop: 10%;\r\n\twidth: 100%;\r\n}\r\n.botones {\r\n\tcolor: white;\r\n\tposition: absolute;\r\n\tfont-size: 45px;\r\n\r\n\t&.boton-volver {\r\n\t\tbottom: 10%;\r\n\t\tleft: 10%;\r\n\t\t.volver-texto {\r\n\t\t\tfont-size: 16px;\r\n\t\t\tfont-family: roboto;\r\n\t\t\tmargin-top: 5px;\r\n\t\t}\r\n\t}\r\n\r\n\t&.boton-camara {\r\n\t\tbottom: 10%;\r\n\t\tleft: 46%;\r\n\t}\r\n\t&.boton-flash {\r\n\t\tbottom: 10%;\r\n\t\tright: 10%;\r\n\t}\r\n\t&:active {\r\n\t\tfont-size: 47px;\r\n\t}\r\n}\r\n.cargando {\r\n\tposition: absolute;\r\n\tbottom: 50%;\r\n\tleft: 46%;\r\n\tfont-size: 45px;\r\n\tcolor: rgb(143, 143, 143);\r\n\t&.hidden {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n// De la documentacion https://github.com/zxing-js/ngx-scanner/wiki/Advanced-Usage\r\n:host zxing-scanner {\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\t//   object-fit: contain;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
